import { CSSProperties, FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

const CELL_STYLE: CSSProperties = {
  padding: '4px 8px',
  whiteSpace: 'nowrap',
  fontSize: '0.75rem',
  color: '#6C6C6C',
  fontWeight: 600,
};

export const TooltipContainer: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      background: '#fff',
      color: '#162C36',
      border: '1px solid #737F86',
      borderRadius: '0.5rem',
      padding: '12px',
      boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
      fontFamily: 'Manrope, sans-serif',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Box>
);

export const TooltipHeader: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography
    sx={{
      fontWeight: 'bold',
      mb: '4px',
      fontSize: '0.75rem',
      color: '#162C36',
      fontFamily: 'Manrope, sans-serif',
    }}
  >
    {children}
  </Typography>
);

export const TooltipBody: FC<{ children: ReactNode }> = ({ children }) => (
  <table>
    <tbody>{children}</tbody>
  </table>
);

export const TooltipRow: FC<{ children: ReactNode }> = ({ children }) => <tr>{children}</tr>;

export const TooltipIndicator: FC<{ color?: string }> = ({ color = '#ccc' }) => (
  <td>
    <Box
      sx={{
        backgroundColor: color,
        width: '10px',
        height: '10px',
        borderRadius: '50%',
      }}
    />
  </td>
);

export const TooltipLabel: FC<{ children: ReactNode; style?: CSSProperties }> = ({
  children,
  style,
}) => <td style={{ ...CELL_STYLE, ...style }}>{children}</td>;

export const TooltipValue: FC<{ children: ReactNode; style?: CSSProperties }> = ({
  children,
  style,
}) => <td style={{ ...CELL_STYLE, ...style }}>{children}</td>;
